let agencias = [
    {
        id: 2770,
        name: 'Sapiranga - Centro',
        cooperativa: 5,
    },
    {
        id: 4734,
        name: 'Sapiranga - São Luiz',
        cooperativa: 5,
    },
]

export {agencias}